import {backendUrl} from "../env";

/**
 * Get the thumbnail URL for a media item.
 */
export const getMediaThumbSrc = (mediaItem) => {
  if (!mediaItem || !mediaItem.path) return null
  return mediaItem.path.absolute_url_thumb
    || (mediaItem.path.thumb ? backendUrl + mediaItem.path.thumb : null)
    || mediaItem.path.absolute_url_normal
    || (mediaItem.path.normal ? backendUrl + mediaItem.path.normal : null)
    || null
}

/**
 * Get the full-size URL for a media item.
 */
export const getMediaFullSrc = (mediaItem) => {
  if (!mediaItem || !mediaItem.path) return null
  return mediaItem.path.absolute_url_normal
    || (mediaItem.path.normal ? backendUrl + mediaItem.path.normal : null)
    || mediaItem.path.absolute_url_filename
    || (mediaItem.path.filename ? backendUrl + mediaItem.path.filename : null)
    || null
}
